module.exports = __webpack_public_path__ + "img/20201112-1.14085d9a.jpg";